"use client";

import { useState } from "react";

import { TurnstileField } from "@/shared/ui/turnstile/TurnstileField";

import styles from "./ConsultationForm.module.css";

type FormTurnstileProps = {
  resetKey: string | number;
  error?: string;
  onTokenChange: (token: string | null) => void;
};

export function FormTurnstile({
  resetKey,
  error,
  onTokenChange,
}: FormTurnstileProps) {
  const [token, setToken] = useState<string | null>(null);

  const handleTokenChange = (value: string | null) => {
    setToken(value);
    onTokenChange(value);
  };

  return (
    <div>
      <TurnstileField
        key={resetKey}
        onSuccess={(value) => handleTokenChange(value)}
        onExpire={() => handleTokenChange(null)}
        onError={() => handleTokenChange(null)}
      />
      {token && (
        <input type="hidden" name="cf-turnstile-response" value={token} />
      )}
      {error && <p className={styles.errorMessage}>{error}</p>}
    </div>
  );
}
